import { Pressable, StyleSheet, View } from "react-native";

import { useTranslation } from "@luna-restaurant/i18n";
import { Icon, useCustomTheme } from "@luna-restaurant/ui";

type BurgerToggleProps = {
  isOpen: boolean;
  onToggle: () => void;
};

export const BurgerToggle = ({ isOpen, onToggle }: BurgerToggleProps) => {
  const { colors } = useCustomTheme();
  const { t } = useTranslation();

  return (
    <Pressable
      testID="burger-toggle"
      onPress={onToggle}
      accessibilityRole="button"
      accessibilityState={{ expanded: isOpen }}
      accessibilityLabel={isOpen ? t("header.closeMenu") : t("header.openMenu")}
      hitSlop={{
        top: 8,
        bottom: 8,
        left: 8,
        right: 8,
      }}
    >
      {isOpen ? (
        <View
          style={[
            styles.iconButton,
            { backgroundColor: colors.palette.spinach30 },
          ]}
        >
          <Icon
            iconSet="material-community"
            icon="close"
            size={24}
            color={colors.background}
          />
        </View>
      ) : (
        <View
          style={[
            styles.iconButton,
            styles.menuButton,
            { borderColor: colors.palette.spinach30 },
          ]}
        >
          <Icon
            iconSet="material-community"
            icon="menu"
            size={28}
            color={colors.text}
          />
        </View>
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  iconButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: "center",
    justifyContent: "center",
  },
  menuButton: {
    borderWidth: 2,
  },
});
